import type { ColorTheme } from '../components/Entry/colorTheme'

export interface Palette {
  id: string
  name: string
  bg: string
  fg: string
  color1: string
  color2: string
}

export const PALETTES: Palette[] = [
  { id: 'dark', name: 'dark', bg: '#0d0d0d', fg: '#e8e8e8', color1: '#c0392b', color2: '#2980b9' },
  { id: 'light', name: 'light', bg: '#f5f5f0', fg: '#1a1a1a', color1: '#c0392b', color2: '#2471a3' },
  { id: 'dracula', name: 'dracula', bg: '#282a36', fg: '#f8f8f2', color1: '#ff5555', color2: '#8be9fd' },
  { id: 'solarized', name: 'solarized', bg: '#002b36', fg: '#839496', color1: '#dc322f', color2: '#268bd2' },
  { id: 'rose pine', name: 'rose pine', bg: '#191724', fg: '#e0def4', color1: '#eb6f92', color2: '#9ccfd8' },
]

export function paletteToTheme(p: Palette): ColorTheme {
  return { bg: p.bg, fg: p.fg, color1: p.color1, color2: p.color2 }
}

export function findMatchingPalette(theme: ColorTheme | null): string | null {
  if (!theme) return null
  const match = PALETTES.find(
    (p) => p.bg === theme.bg && p.fg === theme.fg && p.color1 === theme.color1 && p.color2 === theme.color2
  )
  return match ? `builtin:${match.id}` : null
}
